import { mapState, mapActions, mapGetters } from 'vuex';
import searchMixin from '@/mixins/search';

const SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT = 500;

export default {
  mixins: [
    searchMixin,
  ],
  props: {
    theme: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      focused: false,
      searchQuery: '',
      searchFor: '',
      searchTotal: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('search', ['searchBarVisible']),
    show() {
      return (this.theme === 'default' && this.searchBarVisible) || this.theme !== 'default';
    },
    showSummary() {
      return this.searchTotal === 0;
    },
    classModifiers() {
      return {
        'search-bar': true,
        [`search-bar--${this.theme}`]: this.theme,
      };
    },
    summaryClassModifiers() {
      return {
        'search-bar__summary': true,
        'search-bar__summary--no-results': !this.searchTotal,
      };
    },
    inputClassModifiers() {
      return {
        'search-bar__input': true,
        'search-bar__input--focused': this.focused
      }
    }
  },
  watch: {
    $route() {
      if (this.show) {
        this.onClose();
      }
    },
    show(value) {
      if (value) {
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT);
      }
    },
  },
  methods: {
    ...mapActions('app', ['toggleMobileMenu']),
    ...mapActions('search', ['toggleSearchBar']),
    handleFocus() {
      this.focused = true;
    },
    handleBlur() {
      this.focused = false;
    },
    onSearchResults(data) {
      if (data.totalMarkets > 0) { // close when there are results
        this.onClose();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchTotal = data.totalMarkets;
    },
    onClose() {
      if (this.theme === 'default') {
        this.toggleSearchBar();
      } else if (this.theme === 'menu') {
        this.toggleMobileMenu();
      }
      this.searchFor = '';
      this.searchQuery = '';
      this.searchTotal = null;
    },
    onSubmit() {
      this.searchTotal = null;
      if (this.searchQuery === '') return;
      this.searchFor = this.searchQuery;
      this.doSearch(this.searchQuery);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header/search-bar/search-bar.js